import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function Testimonial() {
  return <section className="w-full bg-slate-50 py-20 sm:py-24" data-id="element-276" data-mp="3luuat7vtwl8b">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-277" data-mp="3lt9i7nt2rcd3">
        <p className="text-center text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-278" data-mp="3gupv3k2qvuj5">
          Provider Perspective
        </p>
        <figure className="mt-5 rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_18px_50px_-24px_rgba(26,27,75,0.25)] sm:p-12" data-id="element-279" data-mp="3cvqrc2sr23ta">
          <QuoteIcon className="h-9 w-9 text-teal/50" data-id="element-280" data-mp="8fxqtd161ble" />
          <blockquote className="mt-6 font-display text-2xl font-medium leading-snug text-navy sm:text-[28px]" data-id="element-281" data-mp="8gh6en3cfnw9">
            “Working with JAG felt less like buying equipment and more like
            adding a partner to our team. The guidance, training, and
            follow-through made the modality something our whole practice could
            actually use with confidence.”
          </blockquote>
          <figcaption className="mt-8 flex items-center gap-4" data-id="element-282" data-mp="2k3xemlbwg0gu">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy font-display text-lg font-bold text-white" data-id="element-283" data-mp="2yjlzrzbwqdp">
              DC
            </span>
            <div data-id="element-284" data-mp="3q2g4l54l0tea">
              <p className="font-semibold text-navy" data-id="element-285" data-mp="3q2zhg7fdkrlg">Dr. Don Casey</p>
              <p className="text-[13px] text-charcoal/70" data-id="element-286" data-mp="3v10x0idle8s6">Practice Owner</p>
            </div>
          </figcaption>
        </figure>
      </div>
    </section>;
}